// 主数据管理-->产品-->中英文
export const productLocale = {
    'zhCN': {
        public: {
            description: '描述',
            productReferred: '产品简称',
            whetherDeleteMateriel: '是否删除该物料?',
            whetherDeletePoductName: '是否删除该产品别名?',
            whetherDeleteClassification: '是否删除该分型?',
            whetherDisableMaterialGroup: '是否停用该分型?',
            whetherDeleteBrand: '是否删除该品牌?',
            whetherDeleteBU: '是否删除该BU?',
            whetherDeleteProductLine: '是否删除该产品线?',
            whetherDeleteBatch: '是否删除该批号管理?',
            whetherDeleteBatchAlias: '是否删除该产品批号?',
            whetherDeleteList: '是否上市该产品?',
            whetherDeleteDelisting: '是否退市该产品?',
            whetherDeleteProductGroup: '是否删除该权限组?',
            whetherStopReceiver: '是否停用该收货方?',
            whetherStartReceiver: '是否启用该收货方?',
            warningProductLineID: '请选择产品线',
            warningName: '品牌名不能为空',
            warningNameLength: '品牌名过长',
            warningDescription: '品牌描述过长',
            warningBUID: '请选择BU',
            warningNameCPX: '产品线名不能为空',
            warningNameLengthCPX: '产品线名过长',
            warningDescriptionCPX: '产品线描述过长',
            warningNameBU: 'BU名不能为空',
            warningNameLengthBU: 'BU名过长',
            warningDescriptionBU: 'BU描述过长',
            delBrandModal: '删除品牌成功!',
            addBrandModal: '添加品牌成功!',
            UpdateBrandModal: '更新品牌成功!',
            delBU: '删除BU成功!',
            addBU: '添加BU成功!',
            UpdateBU: '更新BU成功!',
            successDeleteList: '产品上市成功!',
            retreatDeleteList: '产品退市成功!',
            addDeleteList: '添加产品成功!',
            modifyDeleteList: '修改产品成功!',
            whetherDelNearHosptail: '当前终端存在医院周边药店的关系，停用后该关系将被删除，是否确认要停用并删除该关系？'
        },
        productBatch: {
            materialGroup: '分型',
            materialCode: '物料号',
            material: '物料',
            batch: '批号',
            expiryDate: '有效期',
            manufactureDate: '生产日期',
            customsInDate: '进关日期',
            customsInNumber: '进关数量',
            dateSaleable: '可销售日期',
            creator: '创建人',
            createTime: '创建时间',
            finalEditor: '修改人',
            finalEditTime: '修改时间',
            isDefault: '是否默认批号',
            addBatch: '批号',
            addBatchAlias: '新增批号别名',
            productMaterialCodeMaterial: '产品/分型/物料',
            productMaterialCodeMaterialrequired: '产品/分型/物料必填',
            batchRequired: '批号必填',
            batchNumberLength: '批号过长',
            expiryDateRequired: '有效期必填',
            customsInNumberRequired: '进关数量为数字类型',
            productMaterialCodeMaterialNotValid: '产品/分型/物料未选择物料',
            aliasNotAvailable: '批号別名不能与批号一致',
            thisDefaultBatchNumber: '此批号是默认批号',
            customsInNumberLength: '最大支持9位整数'
        },
        bu: {
            name: 'BU名'
        },
        productLine: {
            name: '产品线'
        },
        brand: {
            name: '品牌名',
            addBrand: '新增品牌',
            editBrand: '编辑品牌',
            productLineManagement: '产品线维护',
            bUManagement: 'BU维护'
        },
        ignoreMaterialHistroy: {
            material: '物料号',
            materialDescription: '物料说明',
            createTime: '忽略时间',
            creator: '忽略人',
            cancelTime: '取消忽略时间',
            cancelUser: '取消忽略人',
            cancelIgnore: '取消忽略',
            uploadListA: '产品批号导入模板下载',
            ignored: '已忽略'
        },
        product: {
            productLine: '产品线',
            franchise: '产品线',
            cdmsProduct: '产品简称',
            brand: '品牌',
            nameCN: '中文名',
            nameEN: 'Brand',
            productName: '产品名',
            genericName: '通用名',
            productType: '产品类型',
            specification: '规格',
            packingSpecifications: '单位数量',
            packing: '包装单位',
            isColdChain: '是否冷链',
            isDoping: '是否兴奋剂',
            isDelisting: '是否退市',
            allMaterial: '全部物料',
            addProduct: '新增产品',
            bu: 'BU',
            addMaterialGroup: '新增分型',
            addMaterial: '新增物料',
            materialDetail: '物料明细',
            productAnother: '产品别名',
            delisting: '退市',
            listing: '上市',
            productManagement: '产品维护',
            materialGroupManagement: '分型维护',
            StandardName: '标准名称',
            ProductStandardName: '产品标准名称',
            ProductStandardNameCN: '中文标准名称',
            ProductionCodeDicCode: '生产标识',
            MaterialGroupStandardName: '分型标准名称',
            materialManagement: '物料维护',
            productAnotherManagement: '产品别名维护',
            buProductLineBrand: 'BU/产品线/品牌',
            dosageForm: '剂型',
            defaultbatchNumber: '默认批号',
            productDefaultBatchNumber: '产品默认批号',
            materialGroup: '分型',
            manufacturer: '生产商',
            packer: '分包商',
            certificateHolder: '持证商',
            materialCode: '物料号',
            material: '物料',
            conversionUnit: '件装量',
            palletizingCapacity: '托装量',
            periodOfValidity: '有效期（月）',
            checkPrice: '考核价',
            checkPriceRequired: '考核价必不能为空',
            standardPrice: '基准价',
            retailPrice: '零售价',
            filingCertificateNumber: '备案号',
            createTime: '创建时间',
            materialManagerment: '物料管理',
            standardCode: '物料本位码',
            isDefaultMaterial: '是否默认物料',
            warningProductProductID: '产品简称不能为空',
            warningProductName: '产品别名',
            warningProductNameLength: '产品别名过长',
            addProductAliasSuccessfully: '添加产品别名成功!',
            successfullyModified: '修改成功!',
            deleteProductAliasSuccessfully: '删除产品别名成功!',
            specificationsBeEmpty: '规格不能为空',
            buProductLineBrandBeEmpty: 'BU/产品线/品牌',
            buProductLineBrandNotSelected: 'BU/产品线/品牌未选择品牌',
            productTypeBeEmpty: '产品类型不能为空',
            dosageFormIDBeEmpty: '剂型不能为空',
            nameCNBeEmpty: '中文名称不能为空',
            nameENLength: 'Brand过长',
            nameENBeEmpty: 'Brand不能为空',
            nameCNLength: '中文名称过长',
            packingLength: '包装单位过长',
            packingSpecificationsLength: '单位数量过长',
            packingBeEmpty: '包装单位不能为空',
            packingSpecificationsBeEmpty: '单位数量不能为空',
            genericNameBeEmpty: '通用名不能为空',
            genericNameLength: '通用名称过长',
            referredBeEmpty: '产品简称不能为空',
            referredLength: '产品简称过长',
            specificationLength: '规格过长',
            defaultBatchNumberBeEmpty: '默认批号不能为空',
            defaultBatchNumberLength: '默认批号过长',
            productLineIDLength: '请选择产品线',
            fieldCannotBeZeroOrEmpty: '该字段不能为零或空',
            pleaseEnterAnInteger: '请输入整数',
            productScoreCannotBeEmpty: '产品/分型不能为空',
            productScoreCannotNot: '产品/分型未选择分型',
            scoreCannotBeEmpty: '产品/分型不能为空',
            materialCodeBeEmpty: '物料号不能为空',
            materialCodeLength: '物料号过长',
            materialBeEmpty: '物料不能为空',
            materialLength: '物料过长',
            conversionUnitBeEmpty: '件装量不能为空',
            palletizingCapacityBeEmpty: '托装量不能为空',
            conversionUnitLength: '最大支持9位整数',
            periodOfValidityBeEmpty: '有效期不能为空',
            periodOfValidityLength: '最大支持9位整数',
            retailPriceBeEmpty: '零售价不能为空',
            retailPriceLength: '最大支持9位整数',
            checkPriceBeEmpty: '最大支持9位整数',
            filingCertificateNumberBeEmpty: '备案号不能为空',
            filingCertificateNumberLength: '备案号过长',
            standardPriceLength: '最大支持9位整数',
            standardCodeLength: '物料本位码过长',
            addMaterialSuccess: '添加物料成功',
            updateMaterialSuccess: '更新物料成功',
            materialGroupBeEmpty: '分型不能为空',
            materialGroupLenght: '分型名称过长',
            manufacturerBeEmpty: '生产商不能为空',
            manufacturerLenght: '生产商过长',
            pckerLength: '分包商过长',
            certificateHolderLength: '持证商过长',
            addMaterialGroupSuccess: '添加分型成功',
            updateMaterialGroupSuccess: '更新分型成功',
            delMaterialGroupSuccess: '删除分型成功',
            checkMaterialHasBatch: '物料下存在批号，不能删除!',
            removeMaterial: '删除物料成功!',
            addProductLine: '添加产品线成功',
            updateProductLine: '更新产品线成功',
            delProductLine: '删除产品线成功',
            enableMaterialGroupSuccess: '启用分型成功',
            disableMaterialGroupSuccess: '停用分型成功',
            taxTypeCode: '税收分类编码',
            isCompensation: '是否补偿',
            isPushGtn: '是否推送GtN',
            month: '年月',
            isSimpleExpropriation: '是否简易征收',
            taxRate: 'VAT',
            importTaxCoefficient: '进口税费系数',
            importerCompensationCoefficient: '进口商补偿系数',
            channelCompensationCoefficient:'渠道补偿系数',
            startDate: '生效日期',
            endDate: '失效日期',
            importOrder: '产品分型排序导入',
            productOrder: '产品排序',
            materialGroupOrder: '分型排序',
            materialGroupCode: '分型编码',
            productIsDelisting: '产品是否退市',
            productStandardNameBeEmpty: '产品标准名称不能为空',
            productStandardNameLength: '产品标准名称过长',
            productStandardNameCNBeEmpty: '中文标准名称不能为空',
            productStandardNameCNLength: '中文标准名称过长',
            materialGroupStandardNameBeEmpty: '分型标准名称不能为空',
            materialGroupStandardNameLength: '分型标准名称过长',
            productionCodeDicIdNameBeEmpty: '生产标识不能为空',
            exportProductOrder: '导出当前排序',
            obversionMaterialGroup: '基准折算分型',
            conversionFactor: '基准折算系数',
            obversionMaterialGroupBeEmpty: '基准折算分型不能为空',
            addObversionMaterialGroupSuccessfully: '新增分型间折算成功',
            editObversionMaterialGroupSuccessfully: '编辑分型间折算成功',
            addTaxCompensationCoefficientSuccessfully: '新增VAT及补偿系数成功',
            editTaxCompensationCoefficientSuccessfully: '编辑VAT及补偿系数成功',
            conversionFactorBeEmpty: '基准折算系数不能为空',
            StartMonthBeEmpty: '生效月份不能为空',
            conversionStartDateBeEmpty: '生效日期不能为空',
            conversionFactorValidate: '基准折算系数最多九位整数，四位小数',
            whetherDeleteObversionMaterialGroup: '是否删除该分型间折算?',
            deleteObversionMaterialGroupSuccessfully: '删除分型间折算成功',
            whetherDeleteTaxCompensationCoefficient: '是否删除该VAT及补偿系数?',
            deleteTaxCompensationCoefficientSuccessfully: '删除VAT及补偿系数成功',
            conversionImport: '导入',
            unitPriceIncludingTaxCompensation: '含税补偿单价',
            priceValidate: '含税补偿单价最多九位整数，四位小数',
            addSimpleExpropriationCompensationUnitPrice: '新增简易征收补偿单价成功',
            editSimpleExpropriationCompensationUnitPrice: '编辑简易征收补偿单价成功',
            whetherShutDownSimpleExpropriationCompensationUnitPrice: '是否删除该简易征收补偿单价?',
            shutDownSimpleExpropriationCompensationUnitPriceSuccessfully: '删除简易征收补偿单价成功',
            unitPriceBeEmpty: '含税补偿单价不能为空',
            startDateBeEmpty: '生效日期不能为空',
            endDateBeEmpty: '结束日期不能为空',
            priceStartDate: '价格生效日期',
            priceEndDate: '价格失效日期',
            compensationUnitPriceIncludingTax: '含税补偿单价',
            compensationUnitPrice: '补偿单价',
            entrust: '折让类型',
            compensationCoefficient: '补偿系数',
            tierOneReceiver: '一级商',
            receiverName: '收货方名称',
            receiverPHCode: '收货方PHCode',
            receiverNameEmpty: '收货方名称不能为空',
            receiverPHCodeEmpty: '收货方PHCode不能为空',
            referenceBidPrice: '参考中标价',
            entrustBeEmpty: '折让类型不能为空',
            addCommissionedImport: '新增委托进口补偿折让单价成功',
            editCommissionedImport: '编辑委托进口补偿折让单价成功',
            whetherCommissionedImport: '是否删除委托进口补偿折让单价?',
            deleteCommissionedImport: '删除委托进口补偿折让单价成功',
            recalculateCommissionedImport: '重新计算委托进口补偿折让单价成功',
            province: '省份',
            provinceBeEmpty: '省份不能为空',
            productionName: '产品简称',
            isSimpleExpropriationBeEmpty: '是否简易征收不能为空',
            taxRateValidateBeEmpty: 'VAT不能为空',
            taxRateValidate: 'VAT最多九位整数，四位小数',
            importTaxCoefficientBeEmpty: '进口税费系数不能为空',
            importTaxCoefficientValidate: '进口税费系数最多九位整数，四位小数',
            importerCompensationCoefficientValidateBeEmpty: '进口商补偿系数不能为空',
            importerCompensationCoefficientValidate: '进口商补偿系数最多九位整数，四位小数',
            ChannelCompensationCoefficientValidateBeEmpty: '渠道补偿系数不能为空',
            ChannelCompensationCoefficientValidate: '渠道补偿系数最多九位整数，四位小数',
            shippingModeBeEmpty: '发货模式不能为空',
            addShippingModeSuccessfully: '新增发货模式成功',
            editShippingModeSuccessfully: '编辑发货模式成功',
            deleteShippingModeSuccessfully: '删除发货模式成功',
            whetherDeleteShippingMode: '是否删除该发货模式?',
            compensationCoefficientValidate: '补偿系数最多九位整数，四位小数',
            compensationCoefficientBeEmpty: '补偿系数不能为空',
            compensationUnitPriceValidate: '补偿单价最多九位整数，四位小数',
            batchDelayedMessage: '是否批量延时委托进口补偿折让单价？',
            batchShrinkMessage: '是否批量缩时委托进口补偿折让单价？',
            startOrEndTime: '有效起止时间',
            receiverNotFound: '未查询到收货方',
        }
    },
    'enUS': {
        public: {
            description: 'Description',
            productReferred: 'Product',
            whetherDeleteMateriel: 'Are you sure you want to delete it?',
            whetherDeletePoductName: 'Are you sure you want to delete it?',
            whetherDeleteClassification: 'Are you sure you want to delete it?',
            whetherDisableMaterialGroup: 'Do you want to disable the materialgroup?',
            whetherDeleteBrand: 'Are you sure you want to delete it?',
            whetherDeleteBU: 'Are you sure you want to delete it??',
            whetherDeleteProductLine: 'Are you sure you want to delete it?',
            whetherDeleteBatch: 'Are you sure you want to delete it?',
            whetherDeleteBatchAlias: 'Are you sure you want to delete it?',
            whetherDeleteList: 'Do you want to enable the product?',
            whetherDeleteDelisting: 'Do you want to disable the product?',
            whetherStopReceiver: 'Do you want to disable the receiver?',
            whetherStartReceiver: 'Do you want to enable the receiver?',
            warningProductLineID: 'Required',
            warningName: 'Required',
            warningNameLength: 'Brand name is too long.',
            warningDescription: 'Brand description is too long.',
            warningBUID: 'Required',
            warningNameCPX: 'Required',
            warningNameLengthCPX: 'Product line name is too long.',
            warningDescriptionCPX: 'Product description is too long.',
            warningNameBU: 'Required',
            warningNameLengthBU: 'BU name is too long.',
            warningDescriptionBU: 'BU description is too long.',
            delBrandModal: 'Success',
            addBrandModal: 'Success',
            UpdateBrandModal: 'Success',
            delBU: 'Success',
            addBU: 'Success',
            UpdateBU: 'Success',
            successDeleteList: 'Success',
            retreatDeleteList: 'Success',
            addDeleteList: 'Success',
            modifyDeleteList: 'Success',
            whetherDelNearHosptail: 'There is a relationship between durgstore around the hospital at the current terminal. After the relationship is deactivated, it will be deleted. Are you sure you want to disable and delete the relationship? '
        },
        productBatch: {
            materialGroup: 'Material Group',
            materialCode: 'Material Code',
            material: 'Material',
            batch: 'Batch',
            expiryDate: 'ExpiryDate',
            manufactureDate: 'ManufactureDate',
            customsInDate: 'CustomsInDate',
            customsInNumber: 'CustomsInNumber',
            dateSaleable: 'DateSaleable',
            creator: 'Creator',
            createTime: 'CreateTime',
            finalEditor: 'FinalEditor',
            finalEditTime: 'FinalEditTime',
            isDefault: 'IsDefaultBatch',
            addBatch: 'Batch',
            addBatchAlias: 'Add BatchAlias',
            productMaterialCodeMaterial: 'Product/Material Group/Material',
            productMaterialCodeMaterialrequired: 'Required',
            batchRequired: 'Required',
            batchNumberLength: 'The batch number is too long',
            expiryDateRequired: 'Required',
            customsInNumberRequired: 'CustomsInNumber must be numeral',
            productMaterialCodeMaterialNotValid: 'The Product/Material Group/Material must choose Material',
            aliasNotAvailable: 'Batch number alias cannot be the same as batch number.',
            thisDefaultBatchNumber: 'This batch number is the default batch number.',
            customsInNumberLength: 'Maximum support for 9 digit integer'
        },
        bu: {
            name: 'BU Name'
        },
        productLine: {
            name: 'Product Line'
        },
        brand: {
            name: 'Brand Name',
            addBrand: 'Add Brand',
            editBrand: 'Edit Brand',
            productLineManagement: 'Product Line Management',
            bUManagement: 'BU Management'
        },
        ignoreMaterialHistroy: {
            material: 'Material',
            materialDescription: 'Description',
            createTime: 'Ignore Time',
            creator: 'Ignore User',
            cancelTime: 'Cancel Time',
            cancelUser: 'Cancel User',
            cancelIgnore: 'Cancel Ignore',
            uploadListA: 'Download template',
            ignored: 'Ignored'
        },
        product: {
            productLine: 'Product Line',
            franchise: 'Franchise',
            cdmsProduct: 'CDMSProduct',
            brand: 'Brand',
            nameCN: 'Name',
            nameEN: 'Brand',
            productName: 'Product Name',
            genericName: 'Generic Name',
            productType: 'Product Type',
            specification: 'Specification',
            isColdChain: 'IsColdChain',
            isDoping: 'IsDoping',
            isDelisting: 'IsDelisting',
            packingSpecifications: 'Packing Specifications',
            packing: 'Packing',
            allMaterial: 'All Material',
            addProduct: 'Add Product',
            bu: 'BU',
            addMaterialGroup: 'Add Group',
            addMaterial: 'Add Material',
            materialDetail: 'MaterialDetail',
            productAnother: 'ProductAnother',
            delisting: 'Delistion',
            listing: 'Listing',
            productManagement: 'Product Management',
            materialGroupManagement: 'Group Manegement',
            StandardName: 'Standard Name',
            ProductStandardName: 'ProductStandard Name',
            ProductStandardNameCN: 'ProductStandardNameCN',
            ProductionCodeDicCode: 'ProductionMark',
            MaterialGroupStandardName: 'MaterialGroup StandardName',
            materialManagement: 'Material Management',
            productAnotherManagement: 'ProductAnother Management',
            buProductLineBrand: 'BU/Product Line/Brand',
            dosageForm: 'DosageForm',
            defaultbatchNumber: 'Default Batch No.',
            materialGroup: 'Material Group',
            manufacturer: 'Manufacturer',
            packer: 'Packer',
            certificateHolder: 'Certificate Holder',
            materialCode: 'Material Code',
            material: 'Material',
            conversionUnit: 'Conversion Unit',
            palletizingCapacity: 'Palletizing Capacity',
            periodOfValidity: 'Period Of Validity',
            checkPrice: 'Check Price',
            checkPriceRequired: 'Required',
            standardPrice: 'Standard Price',
            retailPrice: 'Retail Price',
            filingCertificateNumber: 'Certificate No.',
            createTime: 'Create Time',
            productDefaultBatchNumber: 'Product Batch No.',
            materialManagerment: 'Material Managerment',
            standardCode: 'Standard Code.',
            isDefaultMaterial: 'Is Default Material.',
            warningProductProductID: 'Required',
            warningProductName: 'Product Alias',
            warningProductNameLength: 'Product alias is too long.',
            addProductAliasSuccessfully: 'Success',
            successfullyModified: 'Success',
            deleteProductAliasSuccessfully: 'Success',
            specificationsBeEmpty: 'Required',
            buProductLineBrandBeEmpty: 'Required',
            buProductLineBrandNotSelected: 'Required',
            productTypeBeEmpty: 'Required',
            dosageFormIDBeEmpty: 'Required',
            nameCNBeEmpty: 'Required',
            nameENLength: 'Brand is too long.',
            nameENBeEmpty: 'Required',
            nameCNLength: 'Name is too long.',
            genericNameBeEmpty: 'Required',
            genericNameLength: 'Common name is too long.',
            referredBeEmpty: 'Required',
            referredLength: 'Referred is too long.',
            specificationLength: 'Specification is too long.',
            defaultBatchNumberBeEmpty: 'Required',
            defaultBatchNumberLength: 'Default batch number is too long.',
            productLineIDLength: 'Required',
            fieldCannotBeZeroOrEmpty: 'The field cannot be zero or empty.',
            pleaseEnterAnInteger: 'Integers must be entered.',
            productScoreCannotBeEmpty: 'Required',
            productScoreCannotNot: 'Required',
            scoreCannotBeEmpty: 'Required',
            materialCodeBeEmpty: 'Required',
            materialCodeLength: 'Material code is too long.',
            materialBeEmpty: 'Required',
            materialLength: 'Material is too long.',
            conversionUnitBeEmpty: 'Required',
            palletizingCapacityBeEmpty: 'Required',
            conversionUnitLength: 'Maximum support for 9 digit integer',
            periodOfValidityBeEmpty: 'Required',
            periodOfValidityLength: 'Maximum support for 9 digit integer',
            retailPriceBeEmpty: 'Required',
            retailPriceLength: 'Maximum support for 9 digit integer',
            checkPriceBeEmpty: 'Maximum support for 9 digit integer',
            filingCertificateNumberBeEmpty: 'Required',
            filingCertificateNumberLength: 'Certificate is too long.',
            standardPriceLength: 'Maximum support for 9 digit integer.',
            standardCodeLength: 'Drug standard code is too long.',
            addMaterialSuccess: 'Success',
            updateMaterialSuccess: 'Success',
            materialGroupBeEmpty: 'Required',
            materialGroupLenght: 'Material group is too long.',
            manufacturerBeEmpty: 'Required',
            manufacturerLenght: 'Manufacturer is too long.',
            pckerLength: 'Packaging manufacturer is too long.',
            certificateHolderLength: 'Certificate holder is too long.',
            addMaterialGroupSuccess: 'Success',
            updateMaterialGroupSuccess: 'Success',
            delMaterialGroupSuccess: 'Success',
            checkMaterialHasBatch: 'The material contains batch number and cannot be deleted.',
            removeMaterial: 'Success',
            addProductLine: 'Success',
            updateProductLine: 'Success',
            delProductLine: 'Success',
            enableMaterialGroupSuccess: 'Enable Success',
            disableMaterialGroupSuccess: 'Disable Success',
            taxTypeCode: 'Tax classification code',
            isCompensation: '是否补偿',
            month: 'Month',
            taxRate: 'VAT',
            isSimpleExpropriation: 'Is Simple Expropriation',
            importTaxCoefficient: 'Import Tax Coefficient',
            importerCompensationCoefficient: 'Importer Compensation Coefficient',
            channelCompensationCoefficient:'Channel Compensation Coefficient',
            startDate: 'Start Date',
            endDate: 'End Date',
            importOrder: 'Import Product Order',
            productOrder: 'Product Order',
            materialGroupOrder: 'MaterialGroup Order',
            materialGroupCode: 'MaterialGroup Code',
            productIsDelisting: 'Product Is Delisting',
            productStandardNameBeEmpty: 'Required',
            productStandardNameLength: 'Product standard name is too long.',
            productStandardNameCNBeEmpty: 'Required',
            productStandardNameCNLength: 'Chinese standard name is too long.',
            materialGroupStandardNameBeEmpty: 'Required',
            materialGroupStandardNameLength: 'MaterialGroup standard name is too long.',
            productionCodeDicIdNameBeEmpty: 'Required',
            exportProductOrder: 'Export Product Order',
            obversionMaterialGroup: 'Obversion MaterialGroup',
            conversionFactor: 'Conversion Factor',
            obversionMaterialGroupBeEmpty: 'Required',
            addObversionMaterialGroupSuccessfully: 'Success',
            editObversionMaterialGroupSuccessfully: 'Success',
            addTaxCompensationCoefficientSuccessfully: 'Success',
            editTaxCompensationCoefficientSuccessfully: 'Success',
            addMaterialGroupConversionSuccessfully: 'Add MaterialGroup conversion successfully',
            editMaterialGroupConversionSuccessfully: 'Edit MaterialGroup conversion successfully',
            conversionFactorBeEmpty: 'Required',
            StartMonthBeEmpty: 'Required',
            conversionStartDateBeEmpty: 'Required',
            conversionFactorValidate: 'Conversion Factor up to nine-digit integer, two decimal places',
            whetherDeleteObversionMaterialGroup: 'Are you sure you want to delete it?',
            whetherDeleteTaxCompensationCoefficient: 'Are you sure you want to delete it??',
            deleteTaxCompensationCoefficientSuccessfully: 'Success',
            deleteObversionMaterialGroupSuccessfully: 'Success',
            conversionImport: 'Import',
            unitPriceIncludingTaxCompensation: 'Unit Price Including Tax Compensation',
            priceValidate: 'Conversion Factor up to nine-digit integer, four decimal places',
            addSimpleExpropriationCompensationUnitPrice: 'Add successfully',
            editSimpleExpropriationCompensationUnitPrice: 'Edit successfully',
            whetherShutDownSimpleExpropriationCompensationUnitPrice: 'Are you sure you want to delete it?',
            shutDownSimpleExpropriationCompensationUnitPriceSuccessfully: 'Success',
            unitPriceBeEmpty: 'Unit price can not be empty',
            startDateBeEmpty: 'Start Date can not be empty',
            endDateBeEmpty: 'End Date can not be empty',
            priceStartDate: 'Price Start Date',
            priceEndDate: 'Price End Date',
            compensationUnitPriceIncludingTax: 'Compensation Unit Price Including Tax',
            compensationUnitPrice: 'Compensation Unit Price',
            entrust: 'Entrust Type',
            compensationCoefficient: 'Compensation Coefficient',
            tierOneReceiver: 'Tier One Receiver',
            receiverName: 'Receiver Name',
            receiverPHCode: 'Receiver PHCode',
            receiverNameEmpty: 'Receiver Name can not be empty',
            receiverPHCodeEmpty: 'Receiver PHCode can not be empty',
            referenceBidPrice: 'Reference Bid Price',
            entrustBeEmpty: 'Project Name can not be empty',
            addCommissionedImport: 'Success',
            editCommissionedImport: 'Success',
            whetherCommissionedImport: 'Are you sure you want to delete it?',
            deleteCommissionedImport: 'Success',
            recalculateCommissionedImport: 'Success',
            province: 'Province',
            provinceBeEmpty: 'Province Name can not be empty',
            productionName: 'Production Name',
            isSimpleExpropriationBeEmpty: 'Required',
            taxRateValidateBeEmpty: 'Required',
            taxRateValidate: 'VAT up to nine-digit integer, four decimal places',
            importTaxCoefficientBeEmpty: 'Required',
            importTaxCoefficientValidate: 'Import tax coefficient up to nine-digit integer, four decimal places',
            importerCompensationCoefficientValidateBeEmpty: 'Required',
            importerCompensationCoefficientValidate: 'Importer compensation coefficient up to nine-digit integer, four decimal places',
            ChannelCompensationCoefficientValidateBeEmpty: 'Required',
            ChannelCompensationCoefficientValidate: 'Channel compensation coefficient up to nine-digit integer, four decimal places',
            shippingModeBeEmpty: 'Required',
            compensationCoefficientValidate: 'Compensation coefficient up to nine-digit integer, four decimal places',
            compensationCoefficientBeEmpty: 'Required',
            compensationUnitPriceValidate: 'Compensation unit price up to nine-digit integer, four decimal places',
            batchDelayedMessage: 'Determine the batch delay compensation unit price?',
            batchShrinkMessage: 'Determine the batch time-limited compensation unit price?',
            startOrEndTime: 'Start Or EndTime',
            receiverNotFound: 'Receiver not found',
        }
    }
}
export default productLocale



// WEBPACK FOOTER //
// ./src/locale/modules/productLocale.js